<template>
  <div class="print">

    <section class="section-approval">
      <div>
        <p class="print-title mb-10">안전·보건 순회점검표(사무실)</p>
        <div class="division-title">□ 기본정보</div>
      </div>

      <!-- 결 재 -->
      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0" style="border-bottom: 0;">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재</p>
            </div>
          </th>
          <th class="gray">작성자</th>
          <th class="gray">검토자</th>
          <th class="gray">회람자</th>
          <th class="gray">승인자</th>
        </tr>
        <tr>
          <td>
            <div style="height: 100px">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td>
            <div style="height: 100px">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td>
            <div style="height: 100px">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td>
            <div style="height: 100px">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="w-full h-full object-contain" />
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section-stdInfo mb-10">
      <table class="w-full">
        <colgroup>
        </colgroup>
        <tr>
          <th>회사명</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.field_name }} </div>
          </td>
          <th>작성자 소속</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.section }} </div>
          </td>
        </tr>
        <tr>
          <th>작성자 성명</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.writer_name }} </div>
          </td>
          <th>점검일</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.점검일 }} </div>
          </td>
        </tr>
        <tr>
          <th>점검장소</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.점검장소 }} </div>
          </td>
          <th>재해형태</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.재해형태 }} </div>
          </td>
        </tr>
        <tr>
          <th>점검대상</th>
          <td colspan="3">
            <div class="grid p-4" style="grid-template-columns: 1fr 1fr 1fr 1fr; gap: 1rem;">
              <div v-for="inspect in form.inspectList" class="flex">
                <PrintCheckbox :label="inspect.title" :value="inspect.check"/>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section-inspect mb-10 page-break" v-for="inspect in form.inspectList" v-if="inspect.check">
      <div class="division-title">□ {{ inspect.title }}</div>

      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="180" />
          <col width="180" />
        </colgroup>
        <tr>
          <th>착안사항</th>
          <th>양호</th>
          <th>미흡</th>
          <th>해당<br>없음</th>
          <th>개선요망 사항	</th>
          <th>비고</th>
        </tr>
        <tr v-for="(item, i) in inspect.list" :key="`inspect_${i}`">
          <td>{{ item.content }}</td>
          <td>
            <PrintCheckbox :value="item.isChecked === '양호'" class="flex justify-center"/>
          </td>
          <td>
            <PrintCheckbox :value="item.isChecked === '미흡'" class="flex justify-center"/>
          </td>
          <td>
            <PrintCheckbox :value="item.isChecked === '해당없음'" class="flex justify-center"/>
          </td>
          <td>
            {{ item['개선요망 사항'] }}
          </td>
          <td>
            {{ item['비고'] }}
          </td>
        </tr>
      </table>
    </section>

    <section class="section-file mb-10" style="page-break-before:always;">
      <div class="division-title">□ 현장근로자 의견 청취 및 특이사항</div>
      <table class="w-full">
        <tr>
          <th>현장근로자 의견 청취</th>
          <td class="text-left">{{form.inputC_1.fileName}}</td>
        </tr>
        <tr>
          <th>특이사항</th>
          <td class="p-4 text-left whitespace-pre">{{form.inputC_2}}</td>
        </tr>
      </table>
    </section>

    <section class="section-photo page-break">
      <div class="division-title">□ 사진대지</div>

      <table class="w-full">
        <colgroup>
          <col width="100" />
          <col/>
        </colgroup>
        <template v-for="photo in form.photoList">
          <tr>
            <td colspan="2" style="height: 650px;"><img :src="photo.path" width="100%" height="100%" class="max-w-full w-auto object-contain" /></td>
          </tr>
          <tr>
            <td>내용</td>
            <td class="text-left">{{ photo.input }}</td>
          </tr>
        </template>
      </table>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: {PrintCheckbox},

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
}
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;

    .table-approval-field {
      th { width: 120px; padding: 10px 14px;}
      th:first-child { width: 38px }
      td { height: 80px; }

      tr:last-child {
        th, td { border-bottom: none }
      }
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left
    }
  }

  .section-file {
    th { width: 234px; }
  }

  .section-photo {
    td { padding: 1rem; }
  }
}


@media print {
  .page-break { page-break-inside:avoid; page-break-after:auto }
}
</style>
